import { z } from "zod";
import { ShiftSchemaResponse } from "./shift";
import { AssignmentSchema } from "./assignment";
import { OfferSchema } from "./offer";

export const MessageAttachmentSchema = z.object({
  type: z.enum(["image", "pdf", "file"]),
  url: z.string().url(),
});

export const MessageSchema = z.object({
  id: z.string(),
  senderId: z.string(),
  body: z.string(),
  attachments: z.array(MessageAttachmentSchema).optional(),
  createdAt: z.string(),
  readBy: z.array(z.string()).optional(),
});

export const ConversationSchema = z.object({
  createdAt: z.string(),
  updatedAt: z.string(),
  id: z.number(),
  fromUser: z.string().nullable(),
  toUser: z.string().nullable(),
  shift: ShiftSchemaResponse.nullable(),
  assignment: AssignmentSchema.nullable(),
  offer: OfferSchema.nullable(),
  message: z.string(),
  shift_id: z.number().nullable(),
  assignment_id: z.number().nullable(),
  offer_id: z.number().nullable(),
  conversation_type: z.enum(["CONVERSATION", "OFFER", "PAYMENT"]),
});
export const ConversationFetchResponseSchema = z.object({
  message: z.string().nullable(),
  success: z.boolean(),
  conversation: z.array(ConversationSchema),
  total: z.number(),
});
export type ConversationFetchResponse = z.infer<
  typeof ConversationFetchResponseSchema
>;

export const FetchMessagesResponseSchema = z.object({
  items: z.array(MessageSchema),
  nextCursor: z.string().optional(),
});

export const SendMessageRequestSchema = z.object({
  conversationId: z.string(),
  body: z.string(),
  attachments: z.array(MessageAttachmentSchema).optional(),
});

export const SendMessageResponseSchema = z.object({
  message: z.string().nullable(),
  success: z.boolean(),
  conversation: z.object({
    createdAt: z.string().nullable(),
    updatedAt: z.string().nullable(),
    deletedAt: z.string().nullable(),
    id: z.number(),
    fromUser: z.string(),
    toUser: z.string(),
    shift: ShiftSchemaResponse.nullable(),
    assignment: AssignmentSchema.nullable(),
    offer: OfferSchema.nullable(),
    message: z.string(),
    shift_id: z.number().nullable(),
    assignment_id: z.number().nullable(),
    offer_id: z.number().nullable(),
    conversation_type: z.enum(["CONVERSATION", "OFFER", "PAYMENT"]),
  }),
});

export const ConversationSummarySchema = z.object({
  avatar: z.string().nullable(),
  message: z.string(),
  user_id: z.string(),
  full_name: z.string().nullable(),
  business_name: z.string().nullable(),
  business_image: z.string().nullable(),
  created_at: z.string(),
});

export const ConversationSummaryResponseSchema = z.object({
  message: z.string().nullable(),
  success: z.boolean(),
  conversation: z.array(ConversationSummarySchema),
  total: z.number(),
});

export type ConversationSummary = z.infer<typeof ConversationSummarySchema>;
export type ConversationSummaryResponse = z.infer<
  typeof ConversationSummaryResponseSchema
>;

export type Message = z.infer<typeof MessageSchema>;
export type MessageAttachment = z.infer<typeof MessageAttachmentSchema>;
export type FetchMessagesResponse = z.infer<typeof FetchMessagesResponseSchema>;
export type SendMessageRequest = z.infer<typeof SendMessageRequestSchema>;
export type SendMessageResponse = z.infer<typeof SendMessageResponseSchema>;
